import React from 'react';
import { MapPin, Phone, Instagram, Mail } from 'lucide-react';
import { contactInfo } from '../data/mockData';

const ContactSection = () => {
  return (
    <section id="contact" className="py-20 px-4" style={{ background: 'linear-gradient(to bottom, #0A0015, #1A0520)' }}>
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Kontakt
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-neon-pink to-deep-violet mx-auto rounded-full" />
        </div>
        
        <div className="max-w-2xl mx-auto">
          <div className="glass-card p-8">
            <h3 className="text-2xl font-bold text-neon-pink mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              Besuche uns
            </h3>
            
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <MapPin className="w-6 h-6 text-neon-pink flex-shrink-0 mt-1" style={{ filter: 'drop-shadow(0 0 5px #FF00FF)' }} />
                <div>
                  <p className="text-white font-semibold mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    Adresse
                  </p>
                  <p className="text-white/70" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    {contactInfo.address}
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <Phone className="w-6 h-6 text-deep-violet flex-shrink-0 mt-1" style={{ filter: 'drop-shadow(0 0 5px #8A2BE2)' }} />
                <div>
                  <p className="text-white font-semibold mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    Telefon
                  </p>
                  <a 
                    href={`tel:${contactInfo.phone}`}
                    className="text-white/70 hover:text-neon-pink transition-colors"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    {contactInfo.phone}
                  </a>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <Instagram className="w-6 h-6 text-neon-pink flex-shrink-0 mt-1" style={{ filter: 'drop-shadow(0 0 5px #FF00FF)' }} />
                <div>
                  <p className="text-white font-semibold mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    Instagram
                  </p>
                  <a 
                    href="https://www.instagram.com/saale_lounge?igsh=MXNtdWVoZHR5NjczNw=="
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/70 hover:text-neon-pink transition-colors"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    {contactInfo.instagram}
                  </a>
                </div>
              </div>
            </div>
            
            <div className="mt-8 pt-8 border-t border-neon-pink/20">
              <a 
                href={`https://wa.me/${contactInfo.whatsapp.replace(/\D/g, '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full neon-button flex items-center justify-center gap-2"
                style={{
                  color: 'white'
                }}
              >
                <Phone className="w-5 h-5" style={{ color: 'white' }} />
                WhatsApp Kontakt
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
